'use client'

import React from 'react'
import TileSwiper from '@/src/components/commons/generics/TileSwiper/TileSwiper'
import NumberedHeader from '@/src/components/commons/generics/NumberedHeader/NumberedHeader'
import styles from './GithubRepos.module.scss'
import Link from 'next/link'
import { GithubReposClientProps } from '@/src/components/GithubRepos/GithubReposClient.interface'

const TILE_VARIANT = 'gitRepos'

/**
 * Client component responsible for rendering the interactive swiper inside the container.
 */
export const GithubReposClient: React.FC<GithubReposClientProps> = ({
  repoData,
  txtNumber,
  txtTitle,
}) => {
  const txtSeeAllRepos = 'SEE ALL REPOS'
  const allReposLink = 'https://github.com/ThreatLabz/'
  return (
    <>
      {/* Header Section (07 GitHub Repos) */}
      <div className="mb-[30px] lg:mb-[33px] relative flex justify-between items-center">
        <NumberedHeader number={txtNumber} title={txtTitle} variant="gray" />
        <Link
          href={allReposLink}
          target="_blank"
          className={`
            ${styles.seeAll} 
            hidden md:!flex mr-[20px] lg:mr-[0px] no-underline 
            uppercase text-[14px] font-medium tracking-[1px]
          `}
        >
          {txtSeeAllRepos}
        </Link>
      </div>

      {/* Renders the actual content, TileSwiper */}
      <TileSwiper data={repoData} variant={TILE_VARIANT} />
      <Link
        href={allReposLink}
        target="_blank"
        className={`${styles.seeAll} inline-block md:hidden mr-[20px] no-underline uppercase text-[14px] font-medium tracking-[1px] mt-[30px]`}
      >
        {txtSeeAllRepos}
      </Link>
    </>
  )
}
